"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionMapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const apps_1 = require("../../apps");
function SectionMapper({ componentId, onUpdate, data, onSectionClose, items, }) {
    var _a, _b, _c, _d, _e, _f;
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const Mapper = {
        // cell_bullets: <TextElement size="Body">BulletList</TextElement>,
        // CELL_COLOR: (
        // )
        IMAGE_CORNER: ((0, jsx_runtime_1.jsx)(apps_1.CornerRadius
        //TODO: remove hard coded values
        , { 
            //TODO: remove hard coded values
            radius: 0, maxValue: 0, minValue: 0, value: 0, title: '', variant: 'default', buttonVariant: 'title', onUpdate: onUpdate })),
        EFFECTS: ((0, jsx_runtime_1.jsx)(apps_1.Effects, { onUpdate: onUpdate, textEffects: [
                {
                    type: 'highlight',
                    icon: 'effect-highlight---48',
                    action: 'set-text-highlight',
                    data: data.highlight,
                },
                {
                    type: 'underline',
                    icon: 'effect-underline---48',
                    action: 'set-underline',
                    data: data.underline,
                },
                {
                    type: 'lineThrough',
                    icon: 'effect-line-through---48',
                    action: 'set-line-through',
                    data: data.lineThrough,
                },
                {
                    type: 'stroke',
                    icon: 'effects-stroke---48',
                    action: 'set-text-stroke',
                    data: (_a = data.stroke) === null || _a === void 0 ? void 0 : _a.value,
                },
            ], strokeOptions: (_b = data.stroke) === null || _b === void 0 ? void 0 : _b.options, labels: {
                title: t('popupmenu.effects.title'),
                strokeWeight: t('popupmenu.effects.stroke_weight'),
                strokeColor: t('popupmenu.effects.stroke_color'),
                highlightColor: t('popupmenu.effects.highlight_color'),
            } })),
        TEXT_FONTFAMILY: (0, jsx_runtime_1.jsx)(apps_1.FontFamily, Object.assign({ onUpdate: onUpdate }, data.options)),
        CELL_FONT_FAMILY: (0, jsx_runtime_1.jsx)(apps_1.FontFamily, Object.assign({ onUpdate: onUpdate }, data.options)),
        // text_list: <TextElement size="Body">List</TextElement>,
        // text_bullets: <TextElement size="Body">Bullets</TextElement>,
        TEXT_SPACING: ((0, jsx_runtime_1.jsx)(apps_1.Spacing, { onUpdate: onUpdate, options: (_d = (_c = data.options) === null || _c === void 0 ? void 0 : _c.map) === null || _d === void 0 ? void 0 : _d.call(_c, (option) => {
                var _a, _b, _c, _d;
                return [
                    'paragraphSpacing',
                    'lineSpacing',
                    'wordSpacing',
                    'charSpacing',
                    'firstLineMargin',
                    'startMargin',
                    'endMargin',
                ].includes(option.name)
                    ? Object.assign(Object.assign({}, option), { value: (_a = data[option.name]) === null || _a === void 0 ? void 0 : _a.value, max: (_b = data[option.name]) === null || _b === void 0 ? void 0 : _b.max, min: (_c = data[option.name]) === null || _c === void 0 ? void 0 : _c.min, hide: (_d = data[option.name]) === null || _d === void 0 ? void 0 : _d.hide }) : option;
            }).filter((option) => !option.hide) })),
        TEXT_COLUMNS: ((0, jsx_runtime_1.jsx)(apps_1.Column, { textWidth: data.textWidth, onUpdate: onUpdate, options: (_f = (_e = data.options) === null || _e === void 0 ? void 0 : _e.map) === null || _f === void 0 ? void 0 : _f.call(_e, (option) => {
                var _a, _b, _c;
                return ['columns', 'gap', 'width'].includes(option.name)
                    ? Object.assign(Object.assign({}, option), { value: (_a = data[option.name]) === null || _a === void 0 ? void 0 : _a.value, max: (_b = data[option.name]) === null || _b === void 0 ? void 0 : _b.max, min: (_c = data[option.name]) === null || _c === void 0 ? void 0 : _c.min }) : option;
            }) })),
        VIDEO_SETTINGS: (0, jsx_runtime_1.jsx)(apps_1.Video, { onUpdate: onUpdate, options: data.options }),
        STROKE: ((0, jsx_runtime_1.jsx)(apps_1.Stroke, { onUpdate: onUpdate, options: data.options, value: data.value, labels: {
                strokeWeight: t('popupmenu.effects.stroke_weight'),
                strokeColor: t('popupmenu.effects.stroke_color'),
            } })),
        ROOT_TEXT: ((0, jsx_runtime_1.jsx)(apps_1.SectionText, { onUpdate: onUpdate, options: data.options, onSectionClose: onSectionClose })),
        ROOT_SHAPES: ((0, jsx_runtime_1.jsx)(apps_1.Shapes, { onUpdate: onUpdate, options: data.options, handleShapes: data.shapes, onSectionClose: onSectionClose })),
        POSITION: (0, jsx_runtime_1.jsx)(apps_1.Position, { onUpdate: onUpdate, options: items || [] }),
    };
    return Mapper[componentId];
}
exports.SectionMapper = SectionMapper;
//# sourceMappingURL=SectionMapper.js.map